import { isStreamIQ, isToya } from '@/shared/lib'

export const getTvService = async () => {
    if (isToya()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/toya/services/containers/TVService/TVServiceToya')
            return module.default
        } catch (error) {
            console.warn(
                'TVServiceStreamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    if (isStreamIQ()) {
        try {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const module =
                await require('@/clients/streamiq/services/containers/TVServiceStreamIQ/TVServiceStreamIQ')
            return module.default
        } catch (error) {
            console.warn(
                'TVServiceStreamIQ module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
    throw new Error('Unknown API type')
}
